import { createFileRoute } from "@tanstack/react-router";
import { SecurityPolicyPage } from "@/app/marketing/SecurityPolicyPage";

export const Route = createFileRoute("/security")({
  component: SecurityPolicyPage,
});
